/**
 * Menu drawer scroll lock — Dawn leaves `open` on <details> during close animation;
 * `mobile-drawer-open` + overflow classes can stick. Force unlock when drawer closes.
 */
(() => {
  const UNLOCK_CLASSES = [
    'overflow-hidden',
    'overflow-hidden-mobile',
    'overflow-hidden-tablet',
    'overflow-hidden-desktop',
  ];

  const unlockScroll = () => {
    document.documentElement.classList.remove('mobile-drawer-open');
    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');
    UNLOCK_CLASSES.forEach((cls) => document.body.classList.remove(cls));
  };

  const scheduleUnlock = () => {
    unlockScroll();
    [50, 200, 450, 800].forEach((ms) => window.setTimeout(unlockScroll, ms));
  };

  const patchDrawer = (drawer) => {
    if (!drawer || drawer.dataset.aycanDrawerScroll === '1') return;
    drawer.dataset.aycanDrawerScroll = '1';

    const details = drawer.querySelector('details.menu-drawer-container');
    if (!details) return;

    const onClose = () => {
      if (!details.hasAttribute('open')) scheduleUnlock();
    };

    details.addEventListener('toggle', onClose);

    new MutationObserver(onClose).observe(details, {
      attributes: true,
      attributeFilter: ['open'],
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('header-drawer').forEach(patchDrawer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
